module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"et":{"Select language":"Vali keel"}}')
  delete Component.options._Ctor
}
